import { render, staticRenderFns } from "./latency-circle.component.vue?vue&type=template&id=3a4d9c04&scoped=true&"
import script from "./latency-circle.component.vue?vue&type=script&lang=ts&"
export * from "./latency-circle.component.vue?vue&type=script&lang=ts&"
import style0 from "./latency-circle.component.vue?vue&type=style&index=0&id=3a4d9c04&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4d9c04",
  null
  
)

export default component.exports